import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal'; // eslint-disable-next-line react/display-name

var IconComponent = React.forwardRef(function (props, ref) {
  return React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), React.createElement("g", {
    id: "16x16/phone"
  }, React.createElement("path", {
    id: "Vector",
    d: "M1.73005 2.736C2.4561 2.00939 3.32604 1.4426 4.28405 1.072C4.40705 1.024 4.54405 1 4.69405 1C5.02805 1 5.78005 1.173 5.97405 1.706C6.30305 2.614 6.71405 3.799 7.01405 4.932C7.10205 5.261 7.01405 6.06 6.55205 6.355L5.53605 6.999C5.53005 7.055 5.55105 7.177 5.65105 7.312C6.07869 7.89505 6.54862 8.44587 7.05705 8.96C7.56616 9.4648 8.11235 9.93077 8.69105 10.354C8.84405 10.466 8.96605 10.473 9.00605 10.47L9.65205 9.45C9.95405 8.974 10.718 8.959 10.804 8.959C10.8857 8.95846 10.9672 8.96684 11.047 8.984C12.442 9.296 13.275 9.564 14.342 10.048C14.836 10.271 15.149 11.163 14.929 11.723C14.5601 12.6797 13.9946 13.5484 13.269 14.273C13.063 14.478 12.668 14.982 12.435 14.99C12.201 15 12.015 15 12.015 15C9.34005 15 6.57305 13.768 4.42505 11.62L4.38105 11.574C2.15905 9.334 0.942047 6.51 1.00605 3.784C1.00605 3.784 0.954047 3.642 1.14905 3.396C1.33006 3.16518 1.52404 2.94482 1.73005 2.736Z",
    fill: "currentColor"
  })));
});
/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { Phone16 } from '@cian/ui-kit/icons';`, <br />
 * где 16 - это размер иконки в пикселях.
 */

export var Phone16 = createIcon(IconComponent);